module.exports = __webpack_public_path__ + "static/life-group-0af669058ff3b085485b81cb1e82ae7f.png";